import React, { useContext, useEffect, useMemo, useState } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from "@tanstack/react-table";
import { fetchamcContTable } from "./apiInsights";
import { FilterContext } from "../../context/Filter";

const Amcconttable = () => {
    const { superArn: parArn, childArn } = useContext(FilterContext);
    const [amcContTable, setAmcContTable] = useState([]);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    const getamcContTable = async () => {
        try {
            // console.log("🚀 API Payload:", payload);
            const res = await fetchamcContTable(payload);
            setAmcContTable(res?.result || []); // based on your console log structure
        } catch (error) {
            console.error("❌ Error fetching AMC Contract data:", error);
        }
    };

    useEffect(() => {
        getamcContTable();
    }, []);

    // ✅ Define columns
    const columnHelper = createColumnHelper();
    const columns = useMemo(
        () => [
            columnHelper.accessor("index", {
                header: "S.No",
                cell: (info) => info.getValue(),
            }),
            columnHelper.accessor("assetNumber", {
                header: "Chassis Number",
                cell: (info) => info.getValue(),
            }),
            columnHelper.accessor("vehicleRegNumber", {
                header: "Vehicle Reg. No.",
                cell: (info) => info.getValue(),
            }),
            columnHelper.accessor("amcNumber", {
                header: "AMC Number",
                cell: (info) => info.getValue(),
            }),
            columnHelper.accessor("amcEndDate", {
                header: "AMC End Date",
                cell: (info) => info.getValue(),
            }),
        ],
        []
    );

    // ✅ Table instance
    const table = useReactTable({
        data: amcContTable,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-3 text-center text-blue-700">
                AMC Contract Table
            </h2>

            <div className="overflow-auto max-h-[50vh] border rounded-lg shadow-md">
                <table className="min-w-full border-collapse">
                    <thead className="bg-[#267CB8] text-white sticky top-0">
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                    <th
                                        key={header.id}
                                        className="px-4 py-2 text-left border-b border-blue-400"
                                    >
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody className="text-sm text-gray-800">
                        {table.getRowModel().rows.length > 0 ? (
                            table.getRowModel().rows.map((row) => (
                                <tr
                                    key={row.id}
                                    className="even:bg-blue-50 hover:bg-blue-100 transition-colors"
                                >
                                    {row.getVisibleCells().map((cell) => (
                                        <td key={cell.id} className="px-4 py-2 border-b">
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    className="text-center py-4 text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Amcconttable;
